import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import Layout from "@/components/Layout";
import Lobby from "@/pages/Lobby";
import Dashboard from "@/pages/Dashboard";
import Leaderboard from "@/pages/Leaderboard";
import ProvablyFair from "@/pages/ProvablyFair";
import Admin from "@/pages/Admin";
import Deposit from "@/pages/Deposit";
import Vip from "@/pages/Vip";
import Crash from "@/pages/games/Crash";
import Dice from "@/pages/games/Dice";
import Plinko from "@/pages/games/Plinko";
import Mines from "@/pages/games/Mines";
import Slots from "@/pages/games/Slots";
import MegaSlots from "@/pages/games/MegaSlots";
import Withdraw from "@/pages/Withdraw";

const Protected = ({ children, admin = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141416",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "#F4F4F5",
              },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Lobby />} />
              <Route path="/games/crash" element={<Crash />} />
              <Route path="/games/dice" element={<Dice />} />
              <Route path="/games/plinko" element={<Plinko />} />
              <Route path="/games/mines" element={<Mines />} />
              <Route path="/games/slots" element={<Slots />} />
              <Route path="/games/megaslots" element={<MegaSlots />} />
              <Route path="/withdraw" element={<Protected><Withdraw /></Protected>} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/provably-fair" element={<Protected><ProvablyFair /></Protected>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/deposit" element={<Protected><Deposit /></Protected>} />
              <Route path="/vip" element={<Protected><Vip /></Protected>} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
